<template lang="pug">
  .member(
    :class="{ 'member_stacked': stacked, 'member_muted': muted }"
  )
    .member__container
      .member__main
        .member__img(
          :is="memberLink ? 'a' : 'div'"
          :class="[imgOffset && 'member__img_' + imgOffset, !imgSizeFixed && 'member__img_fluid']"
          :href="memberLink"
          target="_blank"
        )
          Avatar.member__avatar(
            :username="name"
            :img="img"
            :size="imgSize"
          )
        .member__info
          a.member__name(
            :is="memberLink ? 'a' : 'div'"
            :href="memberLink"
            target="_blank"
          )
            slot(
              name="name"
              :shortName="shortName"
              :fullName="name"
            ) {{ name }}
          slot
      .member__actions(v-if="$scopedSlots.actions")
        slot(name="actions")
</template>

<script>
import { mapGetters } from 'vuex';
import Avatar from './Avatar.vue';

export default {
  name: 'Member',
  components: {
    Avatar,
  },
  props: {
    userId: String,
    name: String,
    img: String,
    imgSize: Number,
    info: String,
    link: String,
    imgSizeFixed: {
      type: Boolean,
      default: false,
    },
    stacked: Boolean,
    muted: Boolean,
  },
  computed: {
    ...mapGetters('settings', ['themeMemberLinkDisabled']),
    memberLink() {
      if (!this.themeMemberLinkDisabled) {
        if (this.link) {
          return this.link;
        }

        if (this.userId) {
          return `${window.location.origin}/profile?id=${this.userId}`;
        }

        return null;
      }

      return null;
    },
    imgOffset() {
      return this.imgSize > 48 ? 'lg' : null;
    },
    shortName() {
      const arr = this.name.split(' ');
      return `${arr[1]} ${arr[0].slice(0, 1)}.`;
    },
  },
};
</script>

<style lang="scss">
  .member {

    &_muted {
      transition: $transition-default opacity;
      opacity: 0.45;

      .no-touch &:hover {
        opacity: 1;
      }
    }

    &__container {
      display: flex;
      align-items: center;

      .member_stacked & {

        @media (max-width: breakpoint(md, max)) {
          display: block;
        }
      }
    }

    &__main {
      display: flex;
      align-items: center;
      flex: 1 1 100%;
      min-width: 0;
    }

    &__img {
      display: block;
      flex: 0 0 auto;
      margin-right: 12px;
      text-decoration: none;

      &_lg {
        margin-right: 16px;

        &.member__img_fluid {

          @media (max-width: breakpoint(md, max)) {
            width: 48px;
            max-width: 48px;
            margin-right: 12px;
          }
        }
      }
    }

    &__info {
      @include text-md;
      flex: 1 1 100%;
      font-weight: normal;
    }

    &__name {
      display: block;
      font-weight: $font-weight-semibold;
      color: inherit;
      text-decoration: none;
      @include text-sm;
    }

    &__actions {
      align-items: center;
      flex: 0 0 auto;
      margin-left: 20px;

      .member_stacked & {

        @media (max-width: breakpoint(md, max)) {
          margin-left: 0;
          margin-top: 16px;
        }
      }
    }

    &__buttons {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -4px -8px;

      @media (min-width: breakpoint(md)) {
        flex-direction: column;
      }

      > * {
        flex: 1 0 0;
        white-space: nowrap;
        margin: 0 4px 8px;
      }
    }
  }
</style>
